export default {"src":"/_next/static/media/icon_footer_play.17dee167.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};